"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapContentResponse = exports.mapPresentationDataResponse = void 0;
const FileUploadUtils_1 = require("./FileUploadUtils");
const LocationClient_1 = require("./LocationClient");
const ResourceClient_1 = require("./ResourceClient");
const urls_1 = __importDefault(require("./urls"));
const mapPresentationDataResponse = (p) => ({
    applicationThumbnailUrl: p.application_thumbnail_url,
    thumbnailUrl: p.thumbnail_url,
    applicationIconUrl: p.application_icon_url,
    fileUploads: p.file_uploads
        ? p.file_uploads.map(FileUploadUtils_1.mapFileUploadResponse)
        : null,
});
exports.mapPresentationDataResponse = mapPresentationDataResponse;
const mapContentResponse = (c) => {
    var _a;
    return ({
        id: c.id,
        name: c.name,
        resourceType: c.resource_type,
        resourceId: c.resource_id,
        lastActivityAt: c.last_activity_at,
        updatedAt: c.updated_at,
        createdAt: c.created_at,
        ownedBy: (0, ResourceClient_1.mapResourceProfileResponse)(c.owned_by),
        acl: ((_a = c.acl) === null || _a === void 0 ? void 0 : _a.map((item) => (0, LocationClient_1.mapLocationACLResponse)(item))) || [],
        presentationData: (0, exports.mapPresentationDataResponse)(c.presentation_data),
    });
};
exports.mapContentResponse = mapContentResponse;
class LibraryClient {
    getLibrary(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.library(query),
            });
            return {
                total: res.total,
                data: res.data.map(exports.mapContentResponse),
                folderPath: res.folder_path,
            };
        });
    }
}
exports.default = LibraryClient;
